import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  id: string;
}
export const useSendOneLv = () => {
  const queryClient = useQueryClient();

  const mutationFn = async ({ id }: HookProps) => {
    const result = await apiClient.idms.sendOneDeclaration.mutation({ body: { declarationId: id } });
    if (result.status !== 200) {
      throw result.body;
    }
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declarations'] });
      queryClient.invalidateQueries({ queryKey: ['declaration-groups'] });
      toast.success('Declaration sent successfully!');
    },
    onError: (error) => {
      showErrorToast(error, `Error sending declaration!`);
    },
  });
};
